<template>
    <v-dialog fullscreen v-model="visible">
        <div>
            <box title="نقشه">
                <div slot="top-action-view">
                    <v-btn dark icon @click="visible = false">
                        <v-icon>mdi-close</v-icon></v-btn>
                </div>
                <div class="pa-3">
                    <v-row class="h-100" style="height: 91vh">
                        <v-col id="map">
                            <l-map v-if="mapActive" :options="mapOptions" style="z-index: 0 " :zoom="zoom" :width="widthMap" :center="center"
                                @update:center="centerUpdate">
                                <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                                <l-control-attribution :position="'bottomright'" :prefix="'www.elmosanat.com'" />

                                <div>
                                    <div v-if="location">
                                        <l-marker :lat-lng="getMarkerLatLng(location)"></l-marker>



                                    </div>
                                    <!-- <l-icon
                      v-if="dis"
                      class="new-marker"
                      :icon-size="[50, 50]"
                      :icon-url="require('@/assets/icons/pin-location.svg')"
                    ></l-icon>
                    <l-circle v-if="dis"  :lat-lng="centerMarker" :radius="newRadius" /> -->
                                </div>
                            </l-map>
                        </v-col>
                    </v-row>
                </div>
            </box>
        </div>
    </v-dialog>
</template>
  
<script>
// If you need to reference 'L', such as in 'L.icon', then be sure to
// explicitly import 'leaflet' into your component
import L from "leaflet";
import {
    LMap,
    LTileLayer,
    LMarker,
    LControlAttribution,
    // LCircle,
    // LIcon,
} from "vue2-leaflet";

export default {
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LControlAttribution,
        // LCircle,
        // LIcon,


    },
    data() {
        return {
            dis: false,
            visible: false,
            location: {},
            zoom: 12,
            // center: L.latLng(51.388546,35.687656),
            center: L.latLng(35.687656, 51.388546),
            url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
            attribution: "",
            widthMap: 400,
            mapOptions: {
                zoomControl: true,
                attributionControl: false,
                zoomSnap: true,
            },
            centerMarker: "",
            mapActive:false,
        };
    },
    mounted() {
        this.centerMarker = this.marker
        this.centerMarker = this.center;
        // this.GetGeoLocation();
    },
    methods: {
        show(location) {
            //debugger
            console.log(location);
            this.visible = true;
            this.location = location;
            // this.center = L.latLng(location.Latitude, location.Longtitude);
            this.center = L.latLng(location.Longtitude, location.Latitude);
            this.centerMarker = this.center;
            this.widthMap = 500;
            setTimeout(() => this.mapActive=true, 1000);


        },
        latLng(lat, lng) {
            return L.latLng(lng, lat);
        },
       
        centerUpdate(center) {
            this.centerMarker = this.marker
            this.center = center;
            this.centerMarker = center;
        },
        getMarkerLatLng(marker) {
            // return L.latLng(marker.Latitude, marker.Longtitude);
            return L.latLng(marker.Longtitude, marker.Latitude);
        },

    },
};
</script>
  
<style>
.new-marker {
    color: #569dd6;

}
</style>